import { useState } from 'react'

import Health from './health'
import Fips from './fips'
import Contact from './contact'
import HealthConditions from './health-conditions'
import Medications from './medications'
import Providers from './providers'
import BasicPlans from './basicPlans'
import PredictPlans from './predictPlans'
import Supplemental from './supplemental'
import Preferences from './preferences'

const SECTIONS = [
  {
    title: '1. Create a Contact',
    description: 'Create, update (PUT or PATCH) and get Contact by ID.',
    Component: Contact,
    tourId: 'section-contact'
  },
  {
    title: '2. Get Basic Plans',
    description: 'Basic plans can be retrieved for a contact after a zip/fips code is supplied. By default, only the first 3 plans have supplemental benefits attached.',
    Component: BasicPlans,
    tourId: 'section-basic-plans'
  },
  {
    title: '3. Update Health Conditions',
    description: 'Update health conditions on a contact.',
    Component: HealthConditions,
    tourId: 'section-health'
  },
  {
    title: '4. Update Medications',
    description: 'Search for medications and update medications on a contact.',
    Component: Medications,
    tourId: 'section-medications'
  },
  {
    title: '5. Update Providers (optional)',
    description: 'Search for providers and update providers on a contact.',
    Component: Providers,
    tourId: 'section-providers'
  },
  {
    title: '6. Update Preferences (optional)',
    description: 'Set the plan category (MAPD, PDP, MEDSUPP) and other preferences for the contact.',
    Component: Preferences,
    tourId: 'section-preferences'
  },
  {
    title: '7. Get Predict Plans',
    description: 'Predict plans require a complete contact including health conditions and medications.',
    Component: PredictPlans,
    tourId: 'section-predict-plans'
  },
  {
    title: '8. (Utility) Health Conditions',
    description: 'Utility endpoint used to retrieve a list of the selectable health conditions to assign to a contact.',
    Component: Health
  },
  {
    title: '9. (Utility) FIPS Lookup',
    description: 'Utility endpoint used to get a list of the counties for a given zip code.',
    Component: Fips
  },
  {
    title: '10. (Utility) Supplemental Benefits',
    description: "For MAPD plans only, retrieve the supplemental benefits for a plan by supplying the plan's bidId.",
    Component: Supplemental
  }
]

const AccordionItem = ({ section, isOpen, onToggle, activeSession, callApiFn, isApiCalling, tourId }) => {
  const { title, description, Component } = section

  return (
    <div className='border border-gray-300 rounded mb-1' data-tour={tourId}>
      <button
        className={`w-full text-left px-4 py-3 flex justify-between items-center cursor-pointer ${isOpen ? 'bg-blue-4 font-semibold' : 'bg-white hover:bg-gray-100'}`}
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <span className='text-gray-500'>{isOpen ? '▲' : '▼'}</span>
      </button>
      {isOpen && (
        <div className='p-4 border-t border-gray-300'>
          {description && (
            <p className='text-sm text-gray-600 italic mb-3'>{description}</p>
          )}
          <Component
            activeSession={activeSession}
            callApiFn={callApiFn}
            isApiCalling={isApiCalling}
          />
        </div>
      )}
    </div>
  )
}

const Inputs = ({ activeSession, callApiFn, isApiCalling }) => {
  const [openIdx, setOpenIdx] = useState(null)

  const toggleSection = (idx) => {
    setOpenIdx(openIdx === idx ? null : idx)
  }

  return (
    <div className='flex flex-col basis-2/5'>
      <h3>Medipro Browser</h3>
      {SECTIONS.map((section, idx) => (
        <AccordionItem
          key={idx}
          section={section}
          isOpen={openIdx === idx}
          onToggle={() => toggleSection(idx)}
          activeSession={activeSession}
          callApiFn={callApiFn}
          isApiCalling={isApiCalling}
          tourId={section.tourId}
        />
      ))}
    </div>
  )
}

export default Inputs
